import bundleLocationStep from '~/containers/BundleLocation/step';
import propertyBasicsV2Step from '~/containers/PropertyBasicsV2/step';
import currentPoliciesStep from '~/containers/CurrentPolicies/step';
import propertyAddressStep from '~/containers/PropertyAddress/step';
import confirmationCallScheduledStep from '~/components/Confirmation/steps/callScheduled';
import propertyDetailsStep from '~/containers/PropertyDetails/step';
import propertyFollowupStep from '~/containers/PropertyFollowUp/step';
import propertyUseStep from '~/containers/PropertyUse/step';
import previousAddressStep from '~/containers/PreviousAddress/step';
import applicantInfoStep from '~/containers/ApplicantInfo/step';
import additionalApplicantInfoStep from '~/containers/AdditionalApplicantInfo/step';
import contactInfoStep from '~/containers/ContactInfo/step';
import confirmationStep from '~/components/Confirmation/steps/confirmation';
import discountsStep from '~/containers/Discounts/step';
import homeCoveragesStep from '~/containers/HomeCoverages/step';
import claimsStep from '~/containers/Claims/step';
import driversStep from '~/containers/Drivers/step';
import additionalDriverDetailsStep from '~/containers/AdditionalDriverDetails/step';
import vehiclesStep from '~/containers/Vehicles/step';
import additionalVehicleDetailsStep from '~/containers/AdditionalVehicleDetails/step';
import autoDiscountsStep from '~/containers/AutoDiscounts/step';
import autoCoveragesStep from '~/containers/AutoCoverages/step';
import constructionStep from '~/containers/Construction/step';
import quoteEstimatesStep from '~/containers/QuoteEstimates/step';
import scheduleCallReminder from '~/components/Confirmation/steps/reminder';
import finalizationStep from '~/containers/Finalization/step';
import autoClaimsStep from '~/containers/AutoClaims/step';
import offersStep from '~/containers/Offers/step';

export default [
  bundleLocationStep,
  propertyBasicsV2Step,
  currentPoliciesStep,
  propertyAddressStep,
  constructionStep,
  propertyDetailsStep,
  propertyFollowupStep,
  propertyUseStep,
  discountsStep,
  homeCoveragesStep,
  previousAddressStep,
  claimsStep,
  autoClaimsStep,
  applicantInfoStep,
  additionalApplicantInfoStep,
  driversStep,
  additionalDriverDetailsStep,
  vehiclesStep,
  additionalVehicleDetailsStep,
  autoDiscountsStep,
  autoCoveragesStep,
  contactInfoStep,
  offersStep, // server-side MediaAlpha cards
  quoteEstimatesStep,
  finalizationStep,
  confirmationStep,
  scheduleCallReminder,
  confirmationCallScheduledStep,
];
